<template>
  <div>
    <div class="img_bgc">
      <div class="img_cont">
        <img :src="url" alt="" :style="'height:' + height + 'px'" />
      </div>
      <div class="img_add">
        <a-button shape="circle" icon="plus" @click="add()" />
        <a-button shape="circle" icon="minus" @click="mun()" />
      </div>
      <div class="img_bottom">
        <!-- 底部操作项插槽 -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],
  data() {
    return {
      // url: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180820%2Fb1dd47e40824495bb5f5cfc8b3909735.png&refer=http%3A%2F%2F5b0988e595225.cdn.sohucs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1650615321&t=3e6356c5a1d251268c3d978055e97480",
      height: 400
    }
  },
  methods: {
    add() {
      this.height += 100
    },
    mun() {
      this.height -= 100
    }
  }
}
</script>

<style scoped lang="scss">
.img_bgc {
  z-index: 100;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  // display: flex;
  // align-items: center;
  // justify-content: center;
  .img_cont {
    position: fixed;
    top: 0;
    left: 0;
    height: 85%;
    width: 100%;
    overflow: auto;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    text-align: center;
    line-height: 500px;
  }
  .img_add {
    position: fixed;
    bottom: 150px;
    right: 30px;
    z-index: 999;
  }
  .img_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    // height: 80px;
    background: #fff;
    width: 100%;
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pigImg.vue